import { render, staticRenderFns } from "./SettingsTextColor.vue?vue&type=template&id=16710388&"
import script from "./SettingsTextColor.vue?vue&type=script&lang=js&"
export * from "./SettingsTextColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports